import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import StoreListScreen from '../screens/store/StoreListScreen';
import StoreViewScreen from '../screens/store/StoreViewScreen';
import StoreFormScreen from '../screens/store/StoreFormScreen';
import PlanSelectionScreen from '../screens/subscription/PlanSelectionScreen';
import SubscriptionInvoiceScreen from '../screens/subscription/SubscriptionInvoiceScreen';
import PaymentGatewayScreen from '../screens/subscription/PaymentGatewayScreen';

const Stack = createNativeStackNavigator();

const StoreNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="StoreList" component={StoreListScreen} />
      <Stack.Screen name="StoreView" component={StoreViewScreen} />
      <Stack.Screen name="StoreForm" component={StoreFormScreen} />
      <Stack.Screen name="PlanSelection" component={PlanSelectionScreen} />
      <Stack.Screen name="SubscriptionInvoice" component={SubscriptionInvoiceScreen} />
      <Stack.Screen name="PaymentGateway" component={PaymentGatewayScreen} />
    </Stack.Navigator>
  );
};

export default StoreNavigator;
